"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCategoryRenderings = exports.getStudioCategories = void 0;
const getStudioCategories = (categoryLibrary, product) => {
    if (!categoryLibrary) {
        return [];
    }
    if (!(product === null || product === void 0 ? void 0 : product.configuratorPages)) {
        return [];
    }
    return product.configuratorPages
        .map((pageId) => {
        return categoryLibrary[pageId];
    })
        .filter((x) => x != null);
};
exports.getStudioCategories = getStudioCategories;
const getCategoryRenderings = (category, activeStudioStructure, selections) => {
    const renderingsToDisplay = [];
    const { renderings } = category !== null && category !== void 0 ? category : { renderings: [] };
    if (renderings != null) {
        const renderingArrays = Object.values(renderings).sort((a, b) => Object.keys(a.requiredModifiers).length -
            Object.keys(b.requiredModifiers).length);
        for (const rendering of renderingArrays) {
            const { requiredModifiers } = rendering;
            if (requiredModifiers != null) {
                let foundRendering = true;
                for (const key in requiredModifiers) {
                    if ((selections === null || selections === void 0 ? void 0 : selections[key]) == null) {
                        foundRendering = false;
                        break;
                    }
                }
                if (foundRendering) {
                    let lowestIndex = 10000000;
                    const modifiers = [];
                    // eslint-disable-next-line guard-for-in
                    for (const modifierId in requiredModifiers) {
                        let { modifier, index } = findModifierInActiveStudioStructure(activeStudioStructure, modifierId);
                        if (modifier == null) {
                            modifier = selections === null || selections === void 0 ? void 0 : selections[modifierId];
                        }
                        else {
                            lowestIndex = Math.min(index !== null && index !== void 0 ? index : 10000000, lowestIndex);
                        }
                        modifiers.push(modifier);
                    }
                    const renderingToAdd = Object.assign({
                        index: lowestIndex,
                        modifiers: modifiers,
                        configurationPageId: category.id,
                    }, rendering);
                    renderingsToDisplay.unshift(renderingToAdd);
                }
            }
        }
    }
    return renderingsToDisplay.sort((a, b) => a.index - b.index);
};
exports.getCategoryRenderings = getCategoryRenderings;
const findModifierInActiveStudioStructure = (activeStudioStructure, modifierId) => {
    var _a, _b, _c, _d;
    for (let i = 0; i < activeStudioStructure.length; i++) {
        const category = activeStudioStructure[i];
        if ((_a = category === null || category === void 0 ? void 0 : category.selectedModifierGroups) === null || _a === void 0 ? void 0 : _a.length) {
            for (let j = 0; j < ((_b = category === null || category === void 0 ? void 0 : category.selectedModifierGroups) === null || _b === void 0 ? void 0 : _b.length); j++) {
                const modifierGroup = category === null || category === void 0 ? void 0 : category.selectedModifierGroups[j];
                const modifier = (_c = modifierGroup === null || modifierGroup === void 0 ? void 0 : modifierGroup.selectedModifiers) === null || _c === void 0 ? void 0 : _c.find((m) => (m === null || m === void 0 ? void 0 : m.id) === modifierId);
                if (modifier) {
                    const modifierIndex = (_d = modifierGroup === null || modifierGroup === void 0 ? void 0 : modifierGroup.selectedModifiers) === null || _d === void 0 ? void 0 : _d.findIndex((m) => (m === null || m === void 0 ? void 0 : m.id) === modifierId);
                    return {
                        modifier: modifier,
                        index: i * 10000 + j * 100 + modifierIndex,
                    };
                }
            }
        }
    }
    return { modifier: null, index: 0 };
};
//# sourceMappingURL=category.js.map